"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AssistiveText = _interopRequireDefault(require("../AssistiveText"));

var _utils = require("../../libs/utils");

var _starFill = _interopRequireDefault(require("./starFill"));

var _starBordered = _interopRequireDefault(require("./starBordered"));

var _starContainer = _interopRequireDefault(require("./styled/starContainer"));

var _starInput = _interopRequireDefault(require("./styled/starInput"));

var Star =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Star, _Component);

  function Star(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Star);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Star).call(this, props));
    _this.starId = (0, _utils.uniqueId)('star');
    return _this;
  }

  (0, _createClass2["default"])(Star, [{
    key: "getAssitiveText",
    value: function getAssitiveText() {
      var value = this.props.value;

      if (value === 1) {
        return "".concat(value, " Star");
      }

      return "".concat(value, " Stars");
    }
  }, {
    key: "renderStar",
    value: function renderStar() {
      var filled = this.props.filled;

      if (filled) {
        return _react["default"].createElement(_starFill["default"], null);
      }

      return _react["default"].createElement(_starBordered["default"], null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          name = _this$props.name;
      return _react["default"].createElement(_starContainer["default"], null, _react["default"].createElement(_starInput["default"], {
        type: "radio",
        id: this.starId,
        value: value,
        name: name,
        onChange: onChange
      }), _react["default"].createElement("label", {
        htmlFor: this.starId
      }, this.renderStar(), _react["default"].createElement(_AssistiveText["default"], {
        text: this.getAssitiveText()
      })));
    }
  }]);
  return Star;
}(_react.Component);

exports["default"] = Star;
Star.propTypes = {
  value: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  filled: _propTypes["default"].bool.isRequired,
  name: _propTypes["default"].string
};
Star.defaultProps = {
  value: 1,
  onChange: function onChange() {},
  name: undefined
};